import * as common from "./common"

export const pagesHelper = {
  common,
}
